module.exports = __webpack_public_path__ + "media/images/what-i-do-7f7e2950817adb2835b37b14c4f9a062.jpg";